import * as React from 'react';
import { mergeClasses } from '../constants';
import './LoadingIndicator.scss';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  centered?: boolean;
  children?: React.ReactNode;
  className?: string;
  light?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
};

export default class LoadingIndicator extends React.Component<Props> {
  render() {
    const { centered, children, className, light, size, ...rest } = this.props;

    return (
      <div
        className={mergeClasses([
          'loading-indicator',
          size,
          centered ? 'centered' : null,
          light ? 'light' : null,
          className,
        ])}
        {...rest}
      >
        <div className="spnr">
          <div className="c1 c" />
          <div className="c2 c" />
          <div className="c3 c" />
          <div className="c4 c" />
          <div className="c5 c" />
          <div className="c6 c" />
          <div className="c7 c" />
          <div className="c8 c" />
          <div className="c9 c" />
          <div className="c10 c" />
          <div className="c11 c" />
          <div className="c12 c" />
        </div>
        {children && <div className="ml-3">{children}</div>}
      </div>
    );
  }
}
